import React from "react";
import { Link } from "react-router-dom";
import { getDateAgo } from "../../helper/Helper";
import { ArrowRight } from "lucide-react";

function Card({ item }) {
  return (
    <div className="blog-card">
      {/* Image Wrapper */}
      <div className="blog-image-wrapper">
        <img src={item?.image} alt={item?.title} loading="lazy" />
      </div>

      {/* Overlay Content (Jo hover pe dikhega) */}
      <div className="blog-overlay">
        {item?.date && (
          <div className="blog-date">{getDateAgo(item?.date)}</div>
        )}

        <h4 className="blog-card-title">{item?.title}</h4>

        <p className="blog-excerpt">{item?.shortDescription}</p>

        <Link to={`/blog/${item?.slug}`} className="read-more-link">
          Read Story <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}

export default Card;